<template>
  <div id="app" style="">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        const publicPaths = ['/Login', '/Register', '/Language']
        if(!localStorage.getItem('token') && !publicPaths.includes(this.$route.path)){
           this.$router.replace({path:'/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }

  },
  created(){
    this.getBaseInfo();
  }
}
</script>

<style>
body .van-toast {
  font-size: 24px;
  padding: 30px;
  line-height:30px;
  width: 300px;
  background: linear-gradient(180deg, #6e8dff, #4f67ef) !important;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
*, :after, :before {
  box-sizing: border-box;
}
</style>
